import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { DelayedCircularProgress } from './DelayedCircularProgress';
type Props = {
  title: string;
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  isLoading?: boolean;
};
export function SettingsToggleBar({
  title,
  label,
  value,
  onChange,
  isLoading = false
}: Props) {
  return <Container disableGutters data-sentry-element="Container" data-sentry-component="SettingsToggleBar" data-sentry-source-file="SettingsToggleBar.tsx">
      <Card data-sentry-element="Card" data-sentry-source-file="SettingsToggleBar.tsx">
        <CardContent sx={{
        px: 2,
        py: 0.5,
        '&:last-child': {
          pb: 0.5
        }
      }} data-sentry-element="CardContent" data-sentry-source-file="SettingsToggleBar.tsx">
          <Stack direction="row" alignItems="center" spacing={1} data-sentry-element="Stack" data-sentry-source-file="SettingsToggleBar.tsx">
            <Typography variant="h5" data-sentry-element="Typography" data-sentry-source-file="SettingsToggleBar.tsx">{title}</Typography>
            <FormControlLabel control={<Switch checked={value} onChange={() => onChange(!value)} />} label={label} data-sentry-element="FormControlLabel" data-sentry-source-file="SettingsToggleBar.tsx" />
            <DelayedCircularProgress isLoading={isLoading} size={16} data-sentry-element="DelayedCircularProgress" data-sentry-source-file="SettingsToggleBar.tsx" />
          </Stack>
        </CardContent>
      </Card>
    </Container>;
}